import { render, staticRenderFns } from "./WordMDDocViewer.vue?vue&type=template&id=106d402c&scoped=true&"
import script from "./WordMDDocViewer.vue?vue&type=script&lang=js&"
export * from "./WordMDDocViewer.vue?vue&type=script&lang=js&"
import style0 from "./WordMDDocViewer.vue?vue&type=style&index=0&id=106d402c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106d402c",
  null
  
)

export default component.exports